import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { GlobalUtils } from "../../utils";

const OpportunityDetails = props => {
  const {
    crm_account: {
      name: accountName,
      detailed_address: { street: accountAddress } = {},
    } = {},
    owner: { name: ownerName, image_url: ownerProfileImageUrl } = {},
    stage_name: opportunityStage,
    close_date: opportunityCloseDate,
    updated_at: lastUpdatedAt,
    expected_revenue: expectedRevenue,
  } = props.opportunity;
  return (
    <div className="opportunity-detail">
      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "briefcase"]} />
          </span>
          Account Name:
        </span>
        <span className="opportunity-detail-info">{accountName}</span>
      </span>
      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "list"]} />
          </span>
          Opportunity Stage:
        </span>
        <span className="opportunity-detail-info">
          <span className="opportunity-detail-stage">{opportunityStage}</span>
        </span>
      </span>
      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "user-ninja"]} />
          </span>
          Owner :
        </span>
        <span className="opportunity-detail-info">
          <span className="opportunity-detail-pic">
            <img src={ownerProfileImageUrl} alt="opportunity-img" />
          </span>
          {ownerName}
        </span>
      </span>

      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "building"]} />
          </span>
          Address:
        </span>
        <span className="opportunity-detail-info">
          {accountAddress && accountAddress.split("/n").join(" ")}
        </span>
      </span>

      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "calendar-alt"]} />
          </span>
          Close date:
        </span>
        <span className="opportunity-detail-info">
          {GlobalUtils.formatDate(opportunityCloseDate, "ll")}
        </span>
      </span>

      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "calendar-alt"]} />
          </span>
          Last Updated:
        </span>
        <span className="opportunity-detail-info">
          {GlobalUtils.formatDate(lastUpdatedAt, "lll")}
        </span>
      </span>

      <span className="opportunity-detail-wrapper">
        <span className="opportunity-detail-title">
          <span className="ic-meta">
            <FontAwesomeIcon icon={["far", "money-bill-wave"]} />
          </span>
          Expected Revenue:
        </span>
        <span className="opportunity-detail-info">${expectedRevenue}</span>
      </span>
    </div>
  );
};

export default OpportunityDetails;
